let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1MV5Z")).then(() => parcelRequire('cUqc4'));